import { memo, useEffect, useState } from "react";

import { requestsRepository } from "../../api/RequestsRepository";
import { isGuid } from "../../utils/common";
import { AudioAvatarIcon } from "../icons/AudioAvatarIcon";

export const UserPhoto = memo(({userId, sessionId}: {userId: any, sessionId: any}) => {
    const [photo, setPhoto] = useState<any>(null);
    
    useEffect(() => {
        if (sessionId && userId && isGuid(userId)) {
            requestsRepository.ChatApiService.getUserPhoto(sessionId , userId).then(res => {
                setPhoto(res.success && res.result ? `data:image/jpeg;base64,${res.result}` : null);
            });
        } else {
            setPhoto(null);
        }
    } , [sessionId, userId]);
    
    return photo ? <img width={42} height={42} style={{borderRadius: '50%', objectFit: 'cover'}} src={photo} alt={""} /> : <AudioAvatarIcon size={42}/>;
});